import { useEffect, useReducer } from 'react';
import { isTranslationsLoaded } from './i18n/translationsLoader';
import "./shared/style/css/core.css";
import AppRoutes from "./core/routes";
import api from "./components/api";
import SessionExpiredOverlay from "./components/SessionExpired";
import ThemeSwitch from "./components/ThemeSwitch";

function App() {
  // Das Übersetzungs-Bundle (Datenbank) lädt nach dem ersten Zeichnen → einmal neu zeichnen, damit Menü, Dashboard und Titel in der gewählten Sprache erscheinen
  const [, bump] = useReducer((x) => x + 1, 0);
  useEffect(() => {
    window.addEventListener('translations-updated', bump);
    if (isTranslationsLoaded()) bump();
    return () => window.removeEventListener('translations-updated', bump);
  }, []);

  useEffect(() => {
    // Die Partner-API-Sitzungsprüfung gilt nur für Partner/Fahrer/Admin – auf der öffentlichen Seite wäre sie ein 404 (und ein Fremd-Request)
    if (!["partners.gotransfer24.de", "driver.gotransfer24.de", "admin.gotransfer24.de"].includes(window.location.hostname)) return;
    const checkSession = async () => {
      try {
        await api.get("/session"); // Backend gibt 401, wenn Session abgelaufen
      } catch (err) {
        // Axios Interceptor in api.js übernimmt Redirect auf /login
      }
    };

    checkSession();
  }, []);

  return (
    <div className="app-container">
      <AppRoutes />
      {["partners.gotransfer24.de", "driver.gotransfer24.de", "admin.gotransfer24.de"].includes(window.location.hostname) && <SessionExpiredOverlay />}
      {["partners.gotransfer24.de", "driver.gotransfer24.de", "admin.gotransfer24.de"].includes(window.location.hostname) && <ThemeSwitch />}
    </div>
  );
}

export default App;